import { memo, useState } from "react";
import Form from "../../components/Form.js";
import { useSnackbar } from "../../utils/index.js";
import useSelectStyles from "../../components/styles/Select.js";
import Spinner from "../../components/Spinner.js";
import { Typography, Box, Button } from "@mui/material";
import { getCurrentAnimalOwner } from "../../api/index.js";

const CurrentOwner = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [step, setStep] = useState(1);
    const [selectedAnimal, setSelectedAnimal] = useState();
    const [fetchedOwner, setFetchedOwner] = useState();

    const classes = useSelectStyles();
    const { error } = useSnackbar();

    const selectAnimalFormContent = [
        {
            customType: "input",
            id: "registrationCode",
            type: "text",
            placeholder: "12-ψήφιος Κωδικός Γενεαλογικού Βιβλίου",
            required: true,
        },
        {
            customType: "button",
            id: "submit",
            type: "submit",
            text: "Αναζήτηση"
        },
    ]

    const searchAnimalSubmitForm = async (values) => {
        setIsLoading(true);
        setSelectedAnimal(values.registrationCode);
        const { success: scs, owner, message } = await getCurrentAnimalOwner(values.registrationCode);
        if (scs) {
            setFetchedOwner(owner);
            setStep(2);
        } else {
            error(message);
        }
        setIsLoading(false);
    }

    return (
        <>
            <Spinner open={isLoading} />
            {step === 1 && (
                <>
                    <Box className={classes.outerBox}>
                        <Box container flexDirection="column" className={classes.innerBox}>
                            <Typography variant="h5" sx={{ margin: "1rem" }}>
                                {"Επιλογή Ζώου"}
                            </Typography>
                            <Form
                                content={selectAnimalFormContent}
                                onSubmit={searchAnimalSubmitForm}
                                toResetForm={false}
                            />
                        </Box>
                    </Box>
                </>
            )}
            {step === 2 && (
                <Box
                    sx={{
                        margin: "2rem auto",
                        padding: "1.5rem",
                        backgroundColor: "#f5f5f5",
                        borderRadius: "8px",
                        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                        textAlign: "center",
                        maxWidth: "600px"
                    }}
                >
                    <Typography
                        variant="h5"
                        sx={{
                            marginBottom: "1rem",
                            fontWeight: "bold",
                            color: "#333"
                        }}
                    >
                        Αποτέλεσμα Αναζήτησης
                    </Typography>
                    <Typography
                        variant="body1"
                        sx={{
                            color: "#555",
                            lineHeight: 1.5
                        }}
                    >
                        {`Το ζώο με κωδικό Γενεαλογικού Βιβλίου `}
                        <Typography
                            component="span"
                            sx={{
                                fontWeight: "bold",
                                color: "secondary.main"
                            }}
                        >
                            {selectedAnimal}
                        </Typography>
                        {` ανήκει στην εκτροφή `}
                        <Typography
                            component="span"
                            sx={{
                                fontWeight: "bold",
                                color: "primary.main"
                            }}
                        >
                            {fetchedOwner}
                        </Typography>
                    </Typography>
                    <Button
                        variant="contained"
                        color="primary"
                        sx={{
                            marginTop: "1.5rem",
                            backgroundColor: "secondary.main",
                            ':hover': { backgroundColor: "secondary.dark" }
                        }}
                        onClick={() => setStep(1)}
                    >
                        Πίσω
                    </Button>
                </Box>
            )}

        </>
    )
}

export default memo(CurrentOwner)